import { Dictionary } from "../fable-library.3.7.20/MutableMap.js";
import { disposeSafe, getEnumerator, structuralHash, equals } from "../fable-library.3.7.20/Util.js";
import { addToDict, tryGetValue } from "../fable-library.3.7.20/MapUtil.js";
import { FSharpRef } from "../fable-library.3.7.20/Types.js";
import { getTicks, addMilliseconds, utcNow } from "../fable-library.3.7.20/Date.js";
import { compare } from "../fable-library.3.7.20/Long.js";

export function Cache_get(c, key) {
    return c.Get(key);
}

export function Cache_invalidate(c) {
    c.Invalidate();
}

export function Cache_invalidateKey(c, key) {
    c.InvalidateKey(key);
}

export function Cache_create$0027(internalKey, f) {
    const d = new Dictionary([], {
        Equals: equals,
        GetHashCode: structuralHash,
    });
    return {
        Get(key) {
            const iKey = internalKey(key);
            let x_2 = null;
            if (tryGetValue(d, iKey, new FSharpRef(() => x_2, (v) => {
                x_2 = v;
            }))) {
                return x_2;
            }
            else {
                const x$0027 = f(key);
                addToDict(d, iKey, x$0027);
                return x$0027;
            }
        },
        Invalidate() {
            d.clear();
        },
        InvalidateKey(key_1) {
            let v_1 = null;
            d.delete(internalKey(key_1), new FSharpRef(() => v_1, (v_2) => {
                v_1 = v_2;
            }));
        },
    };
}

export function Cache_create(f) {
    return Cache_create$0027((x) => x, f);
}

export function Cache_compound(f) {
    const c = Cache_create((key0) => Cache_create((key1) => f([key0, key1])));
    return {
        Get(_arg) {
            return c.Get(_arg[0]).Get(_arg[1]);
        },
        Invalidate() {
            c.Invalidate();
        },
        InvalidateKey(_arg_1) {
            c.Get(_arg_1[0]).InvalidateKey(_arg_1[1]);
        },
    };
}

export function Cache_compound3(f) {
    const c = Cache_create((key0) => Cache_create((key1) => Cache_create((key2) => f([key0, key1, key2]))));
    return {
        Get(_arg) {
            return c.Get(_arg[0]).Get(_arg[1]).Get(_arg[2]);
        },
        Invalidate() {
            c.Invalidate();
        },
        InvalidateKey(_arg_1) {
            c.Get(_arg_1[0]).Get(_arg_1[1]).InvalidateKey(_arg_1[2]);
        },
    };
}

export function Cache_createValidated$0027(internalKey, currentState, stateValidator, keyFn, ctor, destructor) {
    const d = new Dictionary([], {
        Equals: equals,
        GetHashCode: structuralHash,
    });
    return {
        Get(inp) {
            const key = keyFn(inp);
            const iKey = internalKey(key);
            const state$0027 = currentState(key);
            let patternInput;
            let x_2 = [null, null];
            if (tryGetValue(d, iKey, new FSharpRef(() => x_2, (v) => {
                x_2 = v;
            }))) {
                patternInput = x_2;
            }
            else {
                const x$0027 = [state$0027, ctor(inp, state$0027)];
                addToDict(d, iKey, x$0027);
                patternInput = x$0027;
            }
            const v_1 = patternInput[1];
            if (stateValidator(patternInput[0], state$0027)) {
                return v_1;
            }
            else {
                const v$0027 = ctor(inp, state$0027);
                d.set(iKey, [state$0027, v$0027]);
                destructor(v_1);
                return v$0027;
            }
        },
        Invalidate() {
            let enumerator = getEnumerator(d);
            try {
                while (enumerator["System.Collections.IEnumerator.MoveNext"]()) {
                    destructor(enumerator["System.Collections.Generic.IEnumerator`1.get_Current"]()[1][1]);
                }
            }
            finally {
                disposeSafe(enumerator);
            }
            d.clear();
        },
        InvalidateKey(inp_1) {
            let v_2 = [null, null];
            if (d.delete(internalKey(keyFn(inp_1)), new FSharpRef(() => v_2, (v_3) => {
                v_2 = v_3;
            }))) {
                destructor(v_2[1]);
            }
        },
    };
}

export function Cache_createValidated(currentState, stateValidator, keyFn, ctor, destructor) {
    return Cache_createValidated$0027((x) => x, currentState, stateValidator, keyFn, ctor, destructor);
}

export function Cache_cacheByKey(ms, key, f) {
    return Cache_createValidated((_key) => utcNow(), (validTo, now) => {
        let copyOfStruct;
        return compare((copyOfStruct = addMilliseconds(validTo, ms), getTicks(copyOfStruct)), getTicks(now)) >= 0;
    }, key, (key_1, _arg) => f(key_1), (_arg_1) => {
    });
}

export function Cache_cache(ms, f) {
    return Cache_cacheByKey(ms, (x) => x, f);
}

export function Cache_cacheByKeyAndDestruct(ms, key, f, destructor) {
    return Cache_createValidated((_key) => utcNow(), (validTo, now) => {
        let copyOfStruct;
        return compare((copyOfStruct = addMilliseconds(validTo, ms), getTicks(copyOfStruct)), getTicks(now)) >= 0;
    }, key, (key_1, _arg) => f(key_1), destructor);
}

export function Cache_cacheAndDestruct(ms, f, destructor) {
    return Cache_cacheByKeyAndDestruct(ms, (x) => x, f, destructor);
}

export function Cache_cacheByKeyOnSuccess(ms, key, f) {
    return Cache_createValidated((_key) => [new FSharpRef(false), utcNow()], (tupledArg, tupledArg_1) => {
        let copyOfStruct;
        return tupledArg[0].contents ? true : (compare((copyOfStruct = addMilliseconds(tupledArg[1], ms), getTicks(copyOfStruct)), getTicks(tupledArg_1[1])) >= 0);
    }, key, (key_1, tupledArg_2) => {
        const v = f(key_1);
        if (v != null) {
            tupledArg_2[0].contents = true;
        }
        return v;
    }, (_arg_2) => {
    });
}

export function Cache_cacheOnSuccess(ms, f) {
    return Cache_cacheByKeyOnSuccess(ms, (x) => x, f);
}

export function Memo_create(f) {
    const c = Cache_create(f);
    return (key) => Cache_get(c, key);
}

export function Memo_compound(f) {
    const c = Cache_compound(f);
    return (key) => Cache_get(c, key);
}

export function Memo_compound3(f) {
    const c = Cache_compound3(f);
    return (key) => Cache_get(c, key);
}

export function Memo_createValidated(currentState, stateValidator, key, ctor) {
    const c = Cache_createValidated(currentState, stateValidator, key, ctor, (_arg) => {
    });
    return (key_1) => Cache_get(c, key_1);
}

export function Memo_cacheByKey(ms, key, f) {
    const c = Cache_cacheByKey(ms, key, f);
    return (key_1) => Cache_get(c, key_1);
}

export function Memo_cacheByKeyOnSuccess(ms, key, f) {
    const c = Cache_cacheByKeyOnSuccess(ms, key, f);
    return (key_1) => Cache_get(c, key_1);
}

export function Memo_cacheOnSuccess(ms, f) {
    const c = Cache_cacheOnSuccess(ms, f);
    return (key) => Cache_get(c, key);
}

export function Memo_cache(ms, f) {
    const c = Cache_cache(ms, f);
    return (key) => Cache_get(c, key);
}

export function Memo_cacheAndDestruct(ms, f, destructor) {
    const c = Cache_cacheAndDestruct(ms, f, destructor);
    return (key) => Cache_get(c, key);
}

